import { select, call, put } from 'redux-saga/effects';

import { getUser } from 'reducers/user';
import api from 'utils/api';
import {
  FetchAvailableProgramsPayloadType,
  fetchAvailableProgramsSuccess,
} from 'actions/availablePrograms';
import { Action, StoreType } from 'reducers/types';
import { fetchErrorHandler } from 'actions/fetchErrorHandler';

export function* fetchAvailablePrograms({
  payload,
}: Action<FetchAvailableProgramsPayloadType>): Generator<any, void, any> {
  const forceUpdate = payload?.forceUpdate ?? false;
  try {
    const { cookies } = yield select(getUser);
    const loaded = yield select((state: StoreType) => state.availablePrograms.loaded);

    if (loaded && !forceUpdate) {
      return;
    }

    const { data } = yield call(api(cookies).get, `/programs/available-for-purchase`);
    yield put(fetchAvailableProgramsSuccess(data));
  } catch (error) {
    // @ts-ignore
    yield put(fetchErrorHandler(error.response, 'Error while fetching available programs'));
  }
}
